import { render, staticRenderFns } from "./HelpPublic.vue?vue&type=template&id=70525741&"
import script from "./HelpPublic.vue?vue&type=script&lang=js&"
export * from "./HelpPublic.vue?vue&type=script&lang=js&"
import style0 from "./HelpPublic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports